import { Step } from '../components/steps/Step';
import { OnboardingFlows } from './common';

export const contentTypeInnovationDepartment: Step = {
    id: OnboardingFlows.UseCases,
    title: 'How do you plan to use D-ID?',
    showCondition: {
        stepId: OnboardingFlows.NewDepartment,
        selectedOption: 'Innovation',
    },
    multiSelect: false,
    randomize: true,
    options: [
        {
            label: 'Ai Agent',
        },
        {
            label: 'Marketing',
        },
        {
            label: 'Learning & Development',
        },
        {
            label: 'Sales',
        },
        {
            label: 'In-App',
        },
        {
            label: 'Customer Support',
        },
        {
            label: 'Content Creation',
        },
        {
            label: 'R&D',
        },
        {
            label: 'AI innovation',
        },
        {
            label: 'Other',
        },
    ],
};
